import React from 'react';
import { EChartsWrapper } from './echarts-wrapper';
import { createAreaChartOption } from '../lib/chart-options';
import type { ChartData } from '@/entities/dashboard';
import type { ExportOptions, ChartExportOptions } from '@/shared/lib/export';

interface AreaChartProps {
  data?: ChartData;
  height?: number | string;
  className?: string;
  loading?: boolean;
  showExport?: boolean;
  exportOptions?: {
    png?: ChartExportOptions;
    csv?: ExportOptions;
    xlsx?: ExportOptions;
  };
  exportPosition?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
}

export const AreaChart: React.FC<AreaChartProps> = ({
  data,
  height,
  className,
  loading,
  showExport,
  exportOptions,
  exportPosition
}) => {
  const emptyData: ChartData = {
    title: '',
    categories: [],
    series: [],
    unitLabel: '',
    metricLabel: ''
  };

  const option = createAreaChartOption(data || emptyData);

  return (
    <EChartsWrapper
      option={option}
      height={height}
      className={className}
      loading={loading}
      showExport={showExport}
      exportOptions={exportOptions}
      exportPosition={exportPosition}
    />
  );
};
